import styled from 'styled-components';

export const StyledReservationDetails = styled.div`
  .form-field-container {
    margin-bottom: 0;

    > div {
      padding-right: 0;
    }
  }
`;
